import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, TextField, Button, Typography, Paper, Chip } from "@mui/material";
import styles from "./ApplicationStatus.module.scss";
import { appStatusSchema } from "../../../forms/appstatusValidation";
import logo from "../../../assets/images/logo-big.png";
import { Link, useNavigate } from "react-router-dom";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { GetUrl, PostUrl } from "../../../api/endpointConfig";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useGet } from "../../../services/hooks/useGet";
import { useLoader } from "../../../Loader/LoaderContext";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { APP_MAINPAGE_URL } from "../../../config/config";
const ApplicationStatus: React.FC = () => {
  const [applicationID, setApplicationID] = useState<number>(0);
  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
      applicationId: "",
    },
    validationSchema: appStatusSchema,
    onSubmit: (values) => {
      console.log("Submitted Values:", values);
      // Execute downstream application logic or API call
    },
  });
  const isMobileFilled = formik.values.mobileNumber.length > 0;
  const isAppIdFilled = formik.values.applicationId.length > 0;
  const navigate = useNavigate();
  // Add this above the component or at the top of the file
  const [openStatusModal, setOpenStatusModal] = useState<boolean>(false);
  const [applicationStatus, setApplicationStatus] = useState<string>("");

  const { showLoader, hideLoader } = useLoader();
  let url = "";
  if (isMobileFilled) {
    url = `${GetUrl.applicationStatusCheck}?phone_number=${formik.values.mobileNumber}`;
  } else if (isAppIdFilled) {
    url = `${GetUrl.applicationStatusCheck}?application_id=${formik.values.applicationId}`;
  }
  const getApplicationData = useGet<any>(url || "", undefined, false);
  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      hideLoader();
      setApplicationID(result?.data?.application_id);
      setApplicationStatus(result?.data?.status || "");
      setOpenStatusModal(true);
    } catch (err: any) {
      hideLoader();
    }
  };
  const submitStatusCheck = () => {
    fetchApplicationData();
  };

  const clickpage = () => {
    localStorage.setItem("applicationID", formik.values.applicationId || applicationID as any);
    localStorage.setItem("mobileNumber", formik.values.mobileNumber);
    localStorage.setItem("applicationStatus", "draft");
    navigate("/applicationcreate");
  };


  
  return (
    <Box className={styles.container}>
      <Paper className={styles.centered}>
        {/* <Box className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </Box> */}
        <Typography variant="h5" mb={3} textAlign="center">
          Application Status
        </Typography>
        <Typography variant="body2" mb={2} textAlign="center">
          Please enter either your Mobile Number or Application ID to check the
          status of your application.
        </Typography>
        <Typography variant="body2" mb={2} textAlign="center">
          Note: You must fill in one of the fields to proceed.
        </Typography>
        <form onSubmit={formik.handleSubmit} className="form-group">
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              fullWidth
              id="mobileNumber"
              name="mobileNumber"
              label="Mobile Number"
              value={formik.values.mobileNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.mobileNumber &&
                Boolean(formik.errors.mobileNumber)
              }
              helperText={
                formik.touched.mobileNumber && formik.errors.mobileNumber
              }
              disabled={isAppIdFilled}
            />
            <Typography variant="body2" textAlign="center">
              OR
            </Typography>
            <TextField
              fullWidth
              id="applicationId"
              name="applicationId"
              label="Application ID"
              value={formik.values.applicationId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.applicationId &&
                Boolean(formik.errors.applicationId)
              }
              helperText={
                formik.touched.applicationId && formik.errors.applicationId
              }
              disabled={isMobileFilled}
            />

            <Box display="flex" justifyContent="center" mt={2} gap={2}>
              <Button
                variant="outlined"
                className={styles.button}
                onClick={() => window.location.href = APP_MAINPAGE_URL}
              >
                Back
              </Button>
              <Button
                type="submit"
                variant="contained"
                className={styles.button}
                onClick={() => {
                  submitStatusCheck();
                }}
                disabled={!isMobileFilled && !isAppIdFilled}
              >
                Check Status
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>

      <Dialog
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {   padding: 24 },
        }}

      >
        <DialogTitle style={{ fontSize: 24, fontWeight: 600 }}>
          Your Application Status
        </DialogTitle>
        <DialogContent className={styles.DialogContent}>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            p={0}
            borderRadius={0}
            boxShadow={0}
            mb={3}
          >
            <Typography variant="h6" fontWeight={500} color="text.secondary">
              Application ID:
            </Typography>
            <Chip
  
              label={formik.values.applicationId || applicationID}
              color="primary"
              variant="outlined"
              className={styles.clipStyle}
            />
          </Box>
          {applicationStatus === "pending_documents" && (
            <>
              <Typography variant="body1" gutterBottom>
                Admin has requested for{" "}
                <span style={{ color: "black", fontWeight: "bold" }}>
                  Additional Documents
                </span>
                . Please click on the link below to provide the same.
              </Typography>
              <Box>
                <Link
                  to={`/additionaldocs/${
                    formik.values.applicationId || applicationID
                  }`}
                  style={{ color: "#1976d2", textDecoration: "underline" }}
                >
                  Upload Documents
                </Link>
              </Box>
            </>
          )}
          {applicationStatus === "pending" && (
            <>
              <Typography variant="body1" gutterBottom>
                Your application is currently{" "}
                <span style={{ color: "blue", fontWeight: "bold" }}>
                  Under Review
                </span>
                . We will notify you once the review process is complete.
              </Typography>
            </>
          )}
          {applicationStatus === "scheduled_interview" && (
            <>
              <Typography variant="body1" gutterBottom>
                Your application has been{" "}
                <span style={{ color: "green", fontWeight: "bold" }}>
                  processed
                </span>
                . SRBF team will contact you for personal interview.
              </Typography>
            </>
          )}
          {applicationStatus === "document_submitted" && (
            <>
              <Typography variant="body1" gutterBottom>
                Your application is currently{" "}
                <span style={{ color: "orange", fontWeight: "bold" }}>
                  In Review
                </span>
                . Please wait while our team processes your application.
              </Typography>
            </>
          )}
          {applicationStatus === "rejected" && (
            <>
              <Typography variant="body1" gutterBottom>
                Your application has been{" "}
                <span style={{ color: "red", fontWeight: "bold" }}>
                  Rejected
                </span>
                .
              </Typography>
            </>
          )}
          {applicationStatus === "approved" && (
            <>
             
              <Typography variant="h6" gutterBottom>
                Your scholarship application has been {" "}
                <span style={{ color: "green", fontWeight: "bold" }}>
                  Approved
                </span>
                .
              </Typography>
              <Typography variant="body1" gutterBottom>
                You are now eligible to receive the benefits under the <span style={{   fontWeight: "bold" }}>SRBF</span> program. Please check your registered email or student portal for further instructions and next steps.
              </Typography>
              <Typography variant="body1" gutterBottom>
                We're excited to support your academic journey!
              </Typography>
            </>
          )}
          {applicationStatus === "draft" && (
            <Typography variant="body1" gutterBottom>
              Your application is presently in{" "}
              <span style={{ color: "orange", fontWeight: "bold" }}>Draft</span>{" "}
              status. Kindly{" "}
              <span
                onClick={clickpage}
                className={styles.clickLink}
              >
                click here
              </span>{" "}
              to continue or complete the submission process.
            </Typography>
          )}
          {applicationStatus === "" && (
            <Typography variant="body1" gutterBottom>
              No application found with the provided details. Please check your
              input and try again.
            </Typography>
          )}
          {/* You can add more details here if needed */}
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "center" }} className={styles.buttonPanel}>
          <Button
            onClick={() => setOpenStatusModal(false)}
            variant="contained"
            size="large"
            autoFocus
            style={{ minWidth: 100, textTransform: 'none' }}
            className={styles.commonButton}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ApplicationStatus;
